<template>
<div class="entryFormInput">
  <form-select v-if="field.inputType === 'select'"
    :name="name"
    :label="field.label"
    :value="field.value"
    :options="field.options"
    :placeholder="field.placeholder"
    :validation="field.rules || {}"
    :layout="layout"
    @input="input"
  ></form-select>

  <form-radio v-else-if="field.inputType === 'radio'"
    :name="name"
    :label="field.label"
    :value="field.value"
    :options="field.options"
    :placeholder="field.placeholder"
    :validation="field.rules || {}"
    :layout="layout"
    @input="input"
  ></form-radio>

  <form-checkbox v-else-if="field.inputType === 'checkbox'"
    :name="name"
    :label="field.label"
    :value="field.value"
    :options="field.options"
    :placeholder="field.placeholder"
    :validation="field.rules || {}"
    :layout="layout"
    @input="input"
  ></form-checkbox>

  <form-birthtime v-else-if="field.inputType === 'birthtime'"
    :name="name"
    :unknown-name="field.unknownName"
    :label="field.label"
    :value="field.value"
    :options="field.options"
    :placeholder="field.placeholder"
    :validation="field.rules || {}"
    :layout="layout"
    @input="input"
  ></form-birthtime>

  <form-birthday v-else-if="field.inputType === 'birthday'"
    :name="name"
    :label="field.label"
    :value="field.value"
    :options="field.options"
    :placeholder="field.placeholder"
    :placeholderYear="field.placeholderYear"
    :placeholderMonth="field.placeholderMonth"
    :placeholderDay="field.placeholderDay"
    :validation="field.rules || {}"
    :layout="layout"
    @input="input"
  ></form-birthday>

  <form-textarea v-else-if="field.inputType === 'textarea'"
    :name="name"
    :label="field.label"
    :value="field.value"
    :rows="field.rows"
    :placeholder="field.placeholder"
    :validation="field.rules || {}"
    :layout="layout"
    @input="input"
  >
    <template slot="aside" v-if="field.aside">
      <p v-html="field.aside" class="u-tx-sub"></p>
    </template>
  </form-textarea>

  <form-password v-else-if="field.inputType === 'password'"
    :name="name"
    :label="field.label"
    :value="field.value"
    :options="field.options"
    :placeholder="field.placeholder"
    :validation="field.rules || {}"
    @input="input"
    :layout="layout"
    :streng-meter="field.strengMeter"
  ></form-password>

  <form-file v-else-if="field.inputType === 'file'"
    :name="name"
    :label="field.label"
    :value="field.value"
    :options="field.options"
    :placeholder="field.placeholder"
    :validation="field.rules || {}"
    :layout="layout"
    @input="input"
  ></form-file>

  <form-input v-else
    :name="name"
    :label="field.label"
    :value="field.value"
    :options="field.options"
    :placeholder="field.placeholder"
    :validation="field.rules || {}"
    :layout="layout"
    @input="input"
  ></form-input>
</div>
</template>

<script>
export default {
  name: 'story-trial-input',
  inject: ['$validator'],
  data: () => ({
    layout: 'row'
  }),
  props: {
    name: {
      type: String,
      required: true
    },
    field: {
      type: Object,
      required: true
    },
    isEditMode: Boolean
  },
  methods: {
    input(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}</script>

<style>
.entryFormInput {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Trial/StoryTrialInput.vue